export default __webpack_public_path__ + "static/media/footerSettings.ad97175c.svg";